import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

/* data imports */
import storyImagesObj from "../game-data/storyImagesObj";
import { dialogueSequenceStart } from "../game-data/towerStoryData";

/* comp imports */
import TypingText from "./TypingText";

/* animation imports */
import {
  elementsEntryExit,
  characterInactive,
} from "../../assets/js/animations";

const TowerStoryWrapperStart = ({ setShowStoryStart, setIsGameStart }) => {
  const [step, setStep] = useState(0);
  const [showNext, setShowNext] = useState(false);
  const current = dialogueSequenceStart[step];

  const handleNext = () => {
    if (step < dialogueSequenceStart.length - 1) {
      setStep(step + 1);
      setShowNext(false);
    } else {
      setShowStoryStart(false);
      setIsGameStart(true);
    }
  };

  const handleSkipStory = () => {
    setShowStoryStart(false);
    setIsGameStart(true);
  };

  return (
    <div className="story-convo-wrapper">
      <div
        className={`character-1-wrapper ${
          current.character === "carrot" ? "" : "low-brightness"
        }`}
      >
        <AnimatePresence>
          {current.imgLinkCarrot && (
            <motion.img
              src={
                current.imgLinkCarrot && storyImagesObj[current.imgLinkCarrot]
              }
              alt="Carrot speaking"
              variants={
                current.character === "carrot"
                  ? elementsEntryExit
                  : characterInactive
              }
              initial="initial"
              animate="animate"
              exit="exit"
            />
          )}
        </AnimatePresence>
      </div>
      <div className="character-convo-wrapper text-center">
        <div className="skip-story" onClick={handleSkipStory}>
          Skip Story <span className="material-symbols-rounded">skip_next</span>
        </div>

        <motion.div
          className={`talk-bubble ${
            current.character === "carrot"
              ? "tri-left"
              : current.character === "broccoli"
              ? "tri-right"
              : ""
          }`}
          variants={elementsEntryExit}
          initial="initial"
          animate="animate"
          exit="exit"
        >
          {current.character === "carrot" ? (
            <div className="story-character-name carrot-name">
              {current.character}
            </div>
          ) : current.character === "broccoli" ? (
            <div className="story-character-name broccoli-name">
              {current.character}
            </div>
          ) : null}
          <div className="talk-text">
            <TypingText
              key={step}
              text={current.text}
              speed={0.04}
              onComplete={() => setShowNext(true)}
            />
            {showNext && (
              <button className="story-next-button" onClick={handleNext}>
                <span className="material-symbols-rounded">resume</span>
              </button>
            )}
          </div>
        </motion.div>
      </div>
      <div
        className={`character-2-wrapper ${
          current.character === "broccoli" ? "" : "low-brightness"
        }`}
      >
        <AnimatePresence>
          {current.imgLinkBroccoli && (
            <motion.img
              src={
                current.imgLinkBroccoli &&
                storyImagesObj[current.imgLinkBroccoli]
              }
              alt="Broccoli speaking"
              variants={
                current.character === "broccoli"
                  ? elementsEntryExit
                  : characterInactive
              }
              initial="initial"
              animate="animate"
              exit="exit"
            />
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default TowerStoryWrapperStart;
